import * as React from "react";
import { LegacyClients, legacyClients } from "./legacyClients/legacyClients";
import {
  competitionsClient,
  datasetsClient,
  kernelsClient,
  searchClient,
  tagsClient,
  usersClient,
  userSecretsClient,
} from "./sdk";

export interface Clients {
  competitionsClient: typeof competitionsClient;
  datasetsClient: typeof datasetsClient;
  kernelsClient: typeof kernelsClient;
  searchClient: typeof searchClient;
  tagsClient: typeof tagsClient;
  usersClient: typeof usersClient;
  userSecretsClient: typeof userSecretsClient;
}

export interface BothClients {
  clients: Clients;
  legacyClients: LegacyClients;
}

export const bothClients: BothClients = {
  clients: {
    competitionsClient,
    datasetsClient,
    kernelsClient,
    searchClient,
    tagsClient,
    usersClient,
    userSecretsClient,
  },
  legacyClients,
};

export const ClientsContext = React.createContext<BothClients>(bothClients);
